/* eslint-disable max-lines */
import { MainEntryAemLabels, MainEntryState } from '../components/main-entry';

export const mockLandingPageAemResponse: MainEntryAemLabels = {
	globalHeader: [
		{
			isSelected: false,
			iconPath: '/content/dam/tmh/customer-portal/en/portal-images/MyToyota_White.png',
			altText: 'My Toyota logo',
			url: '',
			label: '',
			cssClass: '',
			id: '2708cc73-d48c-4301-afa3-ee0bb03002b6',
			submenu: []
		},
		{
			isSelected: false,
			iconPath: '',
			altText: '',
			url: '',
			label: 'Skip Navigation',
			cssClass: '',
			id: '990cdcf6-5612-4d14-9fca-468553692947',
			submenu: []
		}
	],
	banner: {
		bannerImageDesktopView: {
			iconPath: '',
			altText: ''
		},
		bannerImageMobileView: {
			iconPath: '',
			altText: ''
		},
		header: 'MyToyota Customer Portal is Here!',
		subText: 'Now you may register your company and manage locations, users, and permissions to gain 24/7 access.',
		bulletPoints: [
			{
				id: 'a605729f-5c32-42b6-8297-2f4b9302950b',
				label: 'MyFleet Equipment Management'
			},
			{
				id: '56c885b2-cd84-49f0-9e76-1b9dadf487aa',
				label: 'Open Equipment Orders and Order Tracking'
			},
			{
				id: '3f23de83-f375-44e4-9afc-87b7c7aba605',
				label: 'Lease and Financing Information from Toyota Industries Commercial Finance'
			},
			{
				id: '70c1d53b-bd3c-4db1-93a8-72fae67acb00',
				label: 'MyToyota Store to buy forklift parts and accessories'
			}
		],
		registerButton: 'Register/Login'
	},
	iconsDeskTopView: [
		{
			icon: {
				iconPath: '',
				altText: ''
			},
			label: 'MyFleet',
			id: 'ceca2541-a1d3-44b5-bf98-75f987b4873d',
			link: {}
		},
		{
			icon: {
				iconPath: '',
				altText: ''
			},
			label: 'Order Management',
			id: '04802d59-1d31-4176-aa1b-8de105617868',
			link: {}
		},
		{
			icon: {
				iconPath: '',
				altText: ''
			},
			label: 'Financing',
			id: '00dd4c6c-1f05-4e42-beaf-b436d4d80bfc',
			link: {}
		},
		{
			icon: {
				iconPath: '', altText: ''
			},
			label: 'MyInsights',
			id: '5da9ab50-117f-45b1-a1ce-119056b3c47e',
			link: {}
		},
		{
			icon: {
				iconPath: '', altText: ''
			},
			label: 'MyToyota Store',
			id: '3a77b49a-4248-4ff1-ac8f-26eac5289ac0',
			link: {
				text: 'Learn more',
				url: '',
				icon: {
					iconPath: '', altText: ''
				}
			}
		}
	],
	iconsMobileView: [
		{
			icon: {
				iconPath: '',
				altText: ''
			},
			label: 'MyFleet',
			id: 'b7130623-1231-4a4b-87a5-dfbc3ab8a1d7',
			link: {}
		},
		{
			icon: {
				iconPath: '',
				altText: ''
			},
			label: 'Order Management',
			id: 'a5a6cdf2-0650-4a05-9130-65b37f679b1c',
			link: {}
		},
		{
			icon: {
				iconPath: '', altText: ''
			},
			label: 'Financing',
			id: '767eb6e1-ccca-46f3-b6c5-dea5c84ebe74',
			link: {}
		},
		{
			icon: {
				iconPath: '', altText: ''
			},
			label: 'MyInsights',
			id: '79a1a192-3fd5-498b-91f8-642f304ab4b4',
			link: {}
		},
		{
			icon: {
				iconPath: '', altText: ''
			},
			label: 'MyToyota Store',
			id: 'a5f13430-a671-4900-af9e-0f240cf2754e',
			link: {
				text: 'Learn more',
				url: '',
				icon: {
					iconPath: '', altText: ''
				}
			}
		}
	],
	footer: {
		ribbonImage: '',
		altText: '',
		cssClass: '',
		footercontent: {
			css: {
				ecomm: ''
			},
			script: {},
			unifiedFooter: ''
			
			
		}
	},
	tags: [
		{
			id: '', label: '', description: '', type: ''
		},
		{
			id: '', label: '', description: '', type: ''
		}
	]
};

export const mockLandingPageLabels: MainEntryState = {
	isLoading: false,
	sectionTop: {
		globalHeader: [
			{
				isSelected: false,
				iconPath: '',
				altText: '',
				url: '',
				label: '',
				cssClass: '',
				id: '2708cc73-d48c-4301-afa3-ee0bb03002b6',
				submenu: []
			},
			{
				isSelected: false,
				iconPath: '',
				altText: '',
				url: '',
				label: '',
				cssClass: '',
				id: '990cdcf6-5612-4d14-9fca-468553692947',
				submenu: []
			}
		],
		tags: [
			{
				id: '',
				label: '',
				description: '',
				type: ''
			},
			{
				id: '',
				label: '',
				description: '',
				type: ''
			}
		]
	},
	sectionMiddle: {
		banner: {
			bannerImageDesktopView: {
				iconPath: '',
				altText: ''
			},
			bannerImageMobileView: {
				iconPath: '',
				altText: ''
			},
			header: '',
			subText: '',
			bulletPoints: [
				{
					id: 'a605729f-5c32-42b6-8297-2f4b9302950b',
					label: ''
				},
				{
					id: '56c885b2-cd84-49f0-9e76-1b9dadf487aa',
					label: ''
				},
				{
					id: '3f23de83-f375-44e4-9afc-87b7c7aba605',
					label: ''
				},
				{
					id: '70c1d53b-bd3c-4db1-93a8-72fae67acb00',
					label: ''
				}
			],
			registerButton: {
				size: 'large',
				style: 'secondary',
				disabled: false,
				label: '',
				icon: {
					altText: '',
					iconPath: ''
				},
				position: 'none'
			}
		},
		iconsDeskTopView: [
			{
				icon: {
					iconPath: '',
					altText: ''
				},
				label: '',
				id: 'ceca2541-a1d3-44b5-bf98-75f987b4873d',
				link: {}
			},
			{
				icon: {
					iconPath: '',
					altText: ''
				},
				label: '',
				id: '04802d59-1d31-4176-aa1b-8de105617868',
				link: {}
			},
			{
				icon: {
					iconPath: '',
					altText: ''
				},
				label: '',
				id: '00dd4c6c-1f05-4e42-beaf-b436d4d80bfc',
				link: {}
			},
			{
				icon: {
					iconPath: '', altText: ''
				},
				label: '',
				id: '5da9ab50-117f-45b1-a1ce-119056b3c47e',
				link: {}
			},
			{
				icon: {
					iconPath: '', altText: ''
				},
				label: '',
				id: '3a77b49a-4248-4ff1-ac8f-26eac5289ac0',
				link: {
					text: '',
					url: '',
					icon: {
						iconPath: '',
						altText: ''
					}
				}
			}
		],
		iconsMobileView: [
			{
				icon: {
					iconPath: '',
					altText: ''
				},
				label: '',
				id: 'b7130623-1231-4a4b-87a5-dfbc3ab8a1d7',
				link: {}
			},
			{
				icon: {
					iconPath: '',
					altText: ''
				},
				label: '',
				id: 'a5a6cdf2-0650-4a05-9130-65b37f679b1c',
				link: {}
			},
			{
				icon: {
					iconPath: '',
					altText: ''
				},
				label: '',
				id: '767eb6e1-ccca-46f3-b6c5-dea5c84ebe74',
				link: {}
			},
			{
				icon: {
					iconPath: '',
					altText: ''
				},
				label: '',
				id: '79a1a192-3fd5-498b-91f8-642f304ab4b4',
				link: {}
			},
			{
				icon: {
					iconPath: '',
					altText: ''
				},
				label: '',
				id: 'a5f13430-a671-4900-af9e-0f240cf2754e',
				link: {
					text: '',
					url: '',
					icon: {
						iconPath: '',
						altText: ''
					}
				}
			}
		]
	},
	sectionBottom: {
		footer: {
			ribbonImage: '',
			altText: '',
			cssClass: '',
			footercontent: {
				css: {
					ecomm: ''
				},
				script: {},
				unifiedFooter: ''
			}
		}
	}
};
